import { Box, Chip, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

type Props = {
  withSpace?: boolean;
};

export const Wrapper = styled("div")(({ withSpace }: Props) => ({
  padding: withSpace ? "32px 8px" : "auto",
}));

export const CardsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 24,
}));

export const SubcontractorWrapper = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  alignItems: "center",
  marginTop: "16px",
  minHeight: "64px",
}));

export const SwitchWRapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  "& > span": {
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: 0.5,
  },
}));

export const InfoSection = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  borderRadius: 8,
  backgroundColor: colors.gray50,
  padding: 12,
}));

export const InfoText = styled("div")(() => ({
  color: colors.gray600,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0.25,
  fontFamily: "Manrope",
}));

export const TinyInfoText = styled(InfoText)(() => ({
  marginTop: "4px",
  color: colors.gray500,
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: 0.4,
  fontStyle: "normal",
}));

type SelectBranchOptionProps = {
  isRemoving?: boolean;
};

export const SelectBranchOption = styled("span")(({ isRemoving }: SelectBranchOptionProps) => ({
  display: "flex",
  alignItems: "center",
  color: isRemoving ? colors.error600 : colors.brandBlue600,
}));

export const BoxStyled = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  textOverflow: "ellipsis",
  height: 40,
  alignItems: "center",
}));

export const ChipStyled = styled(Chip)(() => ({
  backgroundColor: `#EDF5FB !important`,
  color: `#308cdb !important`,
  fontFamily: "Manrope",
  margin: "2px",
}));

export const AvatarContainer = styled(Grid)(() => ({
  margin: "0px !important",
  maxWidth: "282px !important",
}));

const styles = makeStyles(() => ({
  radioLabel: {
    display: "flex",
    alignItems: "center",
    "& > label": {
      marginBottom: 0,
      marginRight: 8,
    },
  },
  select: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    "& fieldset": {
      "& legend": {
        fontSize: 0,
        margin: 0,
        "& span": {
          display: "none",
        },
      },
    },
  },
  pt32: {
    paddingTop: 32,
  },
  mt32: {
    marginTop: 32,
  },
  my32: {
    marginTop: 32,
    marginBottom: 32,
  },
}));

export default styles;
